<template>
  <v-row class="mt-4">
    <v-col cols="12" md="6" offset-md="3">
      <v-card class="blue lighten-2 mb-5">
        <v-card-title>
          <h2 class="card_title_segundo">
            {{ $t("culminado.card_title_1.titulo") }}
          </h2>
        </v-card-title>
        <v-card-text class="cuerpo_card">
          <h4>
            <img :src="logo_1" class="mr-2" />
            {{ $t("culminado.card_title_1.parrafos[0]") }}
          </h4>

          <h4>
            <img :src="logo_2" class="mr-2" />
            {{ $t("culminado.card_title_1.parrafos[1]") }}
          </h4>

          <h4>
            <img :src="logo_3" class="mr-2" />
            {{ $t("culminado.card_title_1.parrafos[2]") }}
          </h4>

          <h4>
            <img :src="logo_4" class="mr-2" />
            {{ $t("culminado.card_title_1.parrafos[3]") }}
          </h4>

          <h4>
            <img :src="logo_5" class="mr-2" />
            {{ $t("culminado.card_title_1.parrafos[4]") }}
          </h4>

          <h4>
            <img :src="logo_6" class="mr-2" />
            {{ $t("culminado.card_title_1.parrafos[5]") }}
          </h4>
        </v-card-text>
      </v-card>
        <v-card class="blue mt-5">
            <v-card-title>
          <h2 class="card_title_segundo">
            {{ $t("culminado.card_title_2.titulo") }}
          </h2>
        </v-card-title>
        <v-card-text class="cuerpo_card">
          <h4>
            <img :src="logo_7" class="mr-2" />
            {{ $t("culminado.card_title_2.parrafos[0]") }}
          </h4>

          <h4>
            <img :src="logo_8" class="mr-2" />
            {{ $t("culminado.card_title_2.parrafos[1]") }}
          </h4>

          <h4>
            <img :src="logo_9" class="mr-2" />
            {{ $t("culminado.card_title_2.parrafos[2]") }}
          </h4>
        </v-card-text>
        </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
    data : () => ({
        logo_1: require('../assets/logo_1.svg'),
        logo_2: require('../assets/logo_2.svg'),
        logo_3: require('../assets/logo_3.svg'),
        logo_4: require('../assets/logo_4.svg'),
        logo_5: require('../assets/logo_5.svg'),
        logo_6: require('../assets/logo_6.svg'),
        logo_7: require('../assets/logo_7.svg'),
        logo_8: require('../assets/logo_8.svg'),
        logo_9: require('../assets/logo_9.svg')
    })
};
</script>

<style>
h2.card_title_segundo {
  margin-top: 0 !important;
  color: white;
}
.cuerpo_card h4 {
  color: white;
  margin-top: 0 !important;
  font-size: 115%;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
</style>
